export default __webpack_public_path__ + "static/media/pic3.a10aeaa7.jpg";